module.exports = __webpack_public_path__ + "static/shield@3x-6979d2c0754377b8007a882bdef337c8.png";